import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import Plans from './Plans';
import PlanProp from '../../propTypes/PlanProp';
import CartProp from '../../propTypes/CartProp';

class Solutions extends React.Component {
  constructor(props) {
    super(props);

    this.validateAndLeave = this.validateAndLeave.bind(this);
  }

  validateAndLeave(nextStep) {
    const { plan } = this.props.cart;
    this.props.onNavigate({}, nextStep, !!plan);
  }

  render() {
    const {
      t,
      nextStep,
      plans,
      currentUserStats,
      interval,
      selectedPlan,
      onPlanChanged,
      calculatedUserStats,
      onUserCalculationsChanged,
      shouldCalculateActiveUsers,
      hasPermissionToChange,
    } = this.props;

    return (
      <>
        <div className="m-portlet__body">
          <Plans
            currentUserStats={currentUserStats}
            calculatedUserStats={calculatedUserStats}
            onUserCalculationsChanged={onUserCalculationsChanged}
            plans={plans}
            selectedPlan={selectedPlan}
            onPlanChanged={onPlanChanged}
            interval={interval}
            shouldCalculateActiveUsers={shouldCalculateActiveUsers}
            hasPermissionToChange={hasPermissionToChange}
          />
        </div>
        <div className="wizard-content-footer">
          <button
            onClick={() => this.validateAndLeave(nextStep)}
            type="submit"
            className={
              'btn m-btn--pill m-btn--air btn-primary' +
              ' m-btn m-btn--custom wizard-footer-btn'
            }
          >
            {`${t('next')} >`}
          </button>
        </div>
      </>
    );
  }
}

Solutions.propTypes = {
  /** Translation Function */
  t: PropTypes.func.isRequired,
  nextStep: PropTypes.number.isRequired,
  currentUserStats: PropTypes.shape({
    totalUsers: PropTypes.number,
    totalAdmins: PropTypes.number,
  }).isRequired,
  calculatedUserStats: PropTypes.shape({
    totalUsers: PropTypes.number,
    totalAdmins: PropTypes.number,
  }).isRequired,
  onUserCalculationsChanged: PropTypes.func.isRequired,
  /** Handler for navigation event post validation */
  onNavigate: PropTypes.func.isRequired,
  /** Current shopping cart, including number of users per plan */
  cart: PropTypes.shape(CartProp.propType).isRequired,
  plans: PropTypes.arrayOf(PropTypes.shape(PlanProp.propType)).isRequired,
  selectedPlan: PropTypes.shape(PlanProp.propType),
  onPlanChanged: PropTypes.func.isRequired,
  interval: PropTypes.string.isRequired,
  shouldCalculateActiveUsers: PropTypes.bool.isRequired,
  hasPermissionToChange: PropTypes.bool.isRequired,
};

Solutions.defaultProps = {
  selectedPlan: null,
};

export default translate(Solutions);
